export const getColumns = () => {
  return [
    {
      'Header': 'ÁREA',
      'accessor': 'area',
      'width': 3,
    },
    {
      'Header': 'TAREA',
      'accessor': 'serviceCode3',
      'width': 2,
    },
    {
      'Header': 'DESCRIPCIÓN',
      'accessor': 'description',
      'width': 8,
    },
    {
      'Header': 'FLAT RATE STANDARD',
      'accessor': 'stdFlat',
      'width': 2,
    },
    {
      'Header': 'ESTADO',
      'accessor': 'status',
      'width': 1,
      'Filter': () => null,
    },
  ];
};

